var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistrictHeatingBiomass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 27940 21590",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M14618 1842l7104 6261c-219,0 -1340,-28 -1497,37 -143,59 -145,179 -144,373l43 6845 -11011 0 20 -6521c1,-159 41,-292 21,-473 -36,-313 -346,-261 -689,-261 -324,0 -648,0 -972,0l7125 -6261zm-8118 6542l0 0c0,149 69,237 238,237l1886 0 -43 7212 12091 0 -73 -7212 1878 0c385,0 271,-304 60,-491l-7621 -6736c-370,-370 -374,-165 -683,84l-7391 6514c-102,83 -342,251 -342,392z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M12286 13868c-130,0 -280,-105 -280,-237l0 -4686c0,-382 533,-377 561,-43 31,365 -155,324 454,324 199,0 -68,-583 345,-583 495,0 174,583 389,583l367 0c181,0 -122,-583 367,-583 107,0 202,75 245,165 52,110 35,246 35,396 157,37 362,37 519,0 0,-219 -62,-561 302,-561 52,0 120,32 160,56 57,36 83,81 94,143 25,128 -54,384 91,384 192,0 271,16 432,-22 0,-260 -41,-561 302,-561 174,0 281,141 281,346l0 4555c0,363 -461,396 -560,129 -44,-120 25,-345 -88,-345l-388 0c-121,0 -39,220 -73,337 -70,237 -456,242 -536,13 -39,-113 33,-350 -82,-350l-454 0c0,186 27,320 -76,420 -160,154 -513,189 -505,-270 3,-201 10,-150 -498,-150 -23,100 -11,305 -43,368 -42,84 -131,150 -259,150 -464,0 -166,-518 -346,-518l-410 0c-122,0 -38,239 -73,359 -28,95 -158,181 -273,181zm-798 -4944l0 0 0 4642c0,611 605,912 1110,721 102,-38 153,-88 228,-138 179,41 502,394 1123,-22 167,249 673,249 979,72 57,-33 53,-40 101,-72 260,174 248,194 604,194 170,0 406,-100 475,-194 260,174 248,194 605,194 362,0 734,-329 734,-690l0 -4794c0,-349 -366,-669 -842,-669 -238,0 -338,102 -475,194 -89,-23 -425,-336 -886,-129 -83,37 -164,110 -237,129 -47,-31 -43,-38 -101,-72 -351,-203 -656,-144 -979,72 -250,-168 -323,-194 -626,-194 -195,0 -356,136 -475,216 -108,-73 -193,-155 -372,-189 -496,-93 -966,270 -966,729z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M12567 9593l0 3325c0,97 56,42 259,43 108,1 281,36 281,-65l0 -3281c0,-131 -228,-87 -475,-87 -50,0 -65,15 -65,65z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M14769 9593l0 3368c561,0 522,42 521,-149l-2 -3262c-163,-38 -260,-22 -454,-22 -50,0 -65,15 -65,65z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M13668 9593l0 3303c0,107 171,65 454,65 103,0 65,-175 65,-367l0 -3044c-163,-38 -260,-22 -454,-22 -50,0 -65,15 -65,65z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M15849 9593l0 3368 518 0 -1 -3430c-161,-17 -258,-3 -452,-3 -50,0 -65,15 -65,65z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M4967 12147c-15,296 406,292 717,363l943 214c-528,171 -1370,1076 -1583,1551 -793,1774 -196,3616 1490,4553 117,65 1542,674 1542,99 0,-514 -649,3 -1746,-824 -1015,-764 -1382,-2124 -956,-3303 204,-563 888,-1476 1493,-1617 -29,124 -63,228 -99,355l-289 1092c0,141 106,259 280,259 208,0 252,-291 300,-456 60,-206 113,-395 167,-610 57,-233 332,-1117 332,-1266 0,-206 -292,-221 -471,-263l-1209 -259c-208,-44 -893,-236 -911,112z",
    fill: "#0A8E51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M17252 18942c-2,137 160,284 265,383l1265 1196c149,119 330,248 479,68 60,-72 80,-180 28,-293l-1087 -1052 4535 1c322,2 416,-70 408,-276 -11,-291 -289,-240 -508,-240l-4456 -3 879 -848c280,-235 316,-474 130,-563 -304,-144 -442,177 -655,341l-1088 1048c-58,44 -193,171 -195,238z",
    fill: "#0A8E51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M10528 18942c-2,137 160,284 265,383l1265 1196c149,119 330,248 479,68 59,-72 80,-180 28,-293l-1087 -1052 4535 1c322,2 416,-70 408,-276 -11,-291 -289,-240 -508,-240l-4456 -3 879 -848c280,-235 316,-474 129,-563 -303,-144 -441,177 -654,341l-1088 1048c-58,44 -194,171 -195,238z",
    fill: "#0A8E51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrictHeatingBiomass);
export default __webpack_public_path__ + "static/media/district-heating-biomass.c14fc98529872114a58c7e4c9bb51bf9.svg";
export { ForwardRef as ReactComponent };